import { CatHeading } from 'blocks-nextjs/blocks-react/components/Heading';
import { PurifiedHtml } from 'components/purified-html';
import styles from './parts-details.module.scss';

const PartsDetailsTitle = ({
  partNumber,
  partName
}: {
  partNumber: string;
  partName: string;
}) => {
  return (
    <div className="cat-u-padding-bottom-md">
      <div className="d-md-block d-none">
        <CatHeading
          variant="title"
          className={styles['parts-details-title']}
          data-testid="parts-details-title"
        >
          <PurifiedHtml htmlString={`${partNumber}: ${partName}`} />
        </CatHeading>
      </div>
      <div className="d-md-none d-block">
        <CatHeading
          variant="title"
          className={styles['parts-details-title_mobile']}
          data-testid="parts-details-title"
        >
          <PurifiedHtml htmlString={`${partNumber}: ${partName}`} />
        </CatHeading>
      </div>
    </div>
  );
};

export default PartsDetailsTitle;
